import * as Yup from "yup";
const LanguageSchema = Yup.object().shape({
  title: Yup.string().required("Title is Required"),
  symbol: Yup.string().required("Symbol is required"),
  value: Yup.string(),
});
export default LanguageSchema;
